(ns frontend.ui.component.lp-portal.report.overview.historical-net-cash-flows-chart.controller
  (:require
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [color]]
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.utils :as fu]
   [clojure.string :as string]))

(defn ^{:jsdoc ["@nocollapse"]} point-formatter
  [point series-name]
  (str "<strong>"
       series-name
       "</strong>  "
       (util/->percent-1-decimal (/ (aget point "y") 100))
       "<br>"))

(defn historical-net-cash-flows
  [{:keys [labels] :as chart-data-table}]
  {:chart       {:zoomType "xy"}
   :xAxis       [{:categories    labels
                  :lineColor     (theme/color [:chart :x-axis :line])
                  :gridLineColor (theme/color [:chart :x-axis :grid-line])}]
   :yAxis       {:title         :nil
                 :labels        {:format "{value}%"}
                 :lineColor     (theme/color [:chart :y-axis :line])
                 :gridLineColor (theme/color [:chart :y-axis :grid-line])}
   :colors      [(theme/color [:lp-report :chart :bar-1])
                 (theme/color [:lp-report :chart :bar-2])
                 (theme/color [:lp-report :chart :line-1])
                 (theme/color [:lp-report :chart :line-2])]
   :plotOptions {:line {:marker {:enabled false}}}
   :tooltip     {:outside         true
                 :useHtml         true
                 :backgroundColor (theme/color [:page-bg :bg])
                 :style           {:opacity         1
                                   :backgroundColor (theme/color [:page-bg :bg])}
                 :shared          true}
   :series      [{:name    "Semiannual capital calls % of fund size"
                  :type    "column"
                  :data    (->> (:semiannual-capital-calls chart-data-table)
                                (map #(* % 100)))
                  :tooltip {:outside         true
                            :useHtml         true
                            :backgroundColor (theme/color [:page-bg :bg])
                            :style           {:opacity         1
                                              :backgroundColor (theme/color [:page-bg :bg])}
                            :pointFormatter  (fn []
                                               (this-as js-data-point
                                                        (point-formatter
                                                         (js->clj js-data-point
                                                                  :keywordize-keys
                                                                  true)
                                                         "Semiannual capital calls % of fund size")))}}
                 {:name    "Semiannual distributions % of fund size"
                  :type    "column"
                  :data    (->> (:semiannual-distributions chart-data-table)
                                (map #(* % 100)))
                  :tooltip {:outside         true
                            :useHtml         true
                            :backgroundColor (theme/color [:page-bg :bg])
                            :style           {:opacity         1
                                              :backgroundColor (theme/color [:page-bg :bg])}
                            :pointFormatter  (fn []
                                               (this-as js-data-point
                                                        (point-formatter
                                                         (js->clj js-data-point
                                                                  :keywordize-keys
                                                                  true)
                                                         "Semiannual distributions % of fund size")))}}
                 {:name    "Cumulative net cash flow to investors % of fund size"
                  :type    "line"
                  :data    (->> (:cumulative-net-cash-to-investors chart-data-table)
                                (map #(* % 100)))
                  :tooltip {:outside         true
                            :useHtml         true
                            :backgroundColor (theme/color [:page-bg :bg])
                            :style           {:opacity         1
                                              :backgroundColor (theme/color [:page-bg :bg])}
                            :pointFormatter
                            (fn []
                              (this-as js-data-point
                                       (point-formatter
                                        (js->clj js-data-point
                                                 :keywordize-keys
                                                 true)
                                        "Cumulative net cash flow to investors % of fund size")))}}
                 {:name    "Cumulative capital calls % of fund size"
                  :type    "line"
                  :data    (->> (:cumulative-capital-calls chart-data-table)
                                (map #(* % 100)))
                  :tooltip {:outside         true
                            :useHtml         true
                            :backgroundColor (theme/color [:page-bg :bg])
                            :style           {:opacity         1
                                              :backgroundColor (theme/color [:page-bg :bg])}
                            :pointFormatter  (fn []
                                               (this-as
                                                js-data-point
                                                (point-formatter
                                                 (js->clj js-data-point
                                                          :keywordize-keys
                                                          true)
                                                 "Cumulative capital calls % of fund size")))}}]})
